import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter } from "react-router-dom";
import { Suspense } from "react";
import Preloader from "./components/Preloader/preloader";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "../src/App";
import PC_OR_Mob from "./components/common/PC_OR_Mob"
ReactDOM.render(
  <Suspense fallback={<Preloader/>}>
  <BrowserRouter basename="#">
      <PC_OR_Mob/>
  </BrowserRouter>
  </Suspense>
  ,
  document.getElementById("root")
);
